import * as Locales from "date-fns/locale";
import { Locale } from "date-fns";
import { de } from "date-fns/locale";

// use dateFns local names for locale: https://github.com/date-fns/date-fns/tree/main/src/locale
export function getDateFnsLocale(localeString: string): Locale {
  return Locales[localeString] ?? de;
}
